import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faCheckCircle, faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';

import { atoms } from '../../css/atoms/atoms.css';

import { Text } from '../Text/Text';

type FieldMessageTone = 'positive' | 'neutral' | 'critical' | 'caution';

export interface FieldMessageProps {
  id?: string;
  message?: string;
  tone?: FieldMessageTone;
}

const resolveMessageIcon = {
  positive: faCheckCircle,
  neutral: undefined,
  critical: faTimesCircle,
  caution: faExclamationTriangle,
};

export const FieldMessage: React.FC<FieldMessageProps> = ({ id, message, tone }) => {
  const messageIcon = resolveMessageIcon[tone || 'neutral'];

  return (
    <Text id={id} tone={tone} size="small" weight="demibold">
      {messageIcon && (
        <span
          className={atoms({
            paddingRight: 'xxsmall',
          })}
        >
          <FontAwesomeIcon icon={messageIcon} />
        </span>
      )}
      {message}
    </Text>
  );
};
